import { isObject } from '@aviata/type-guards';
import { isArray, isNumber } from 'lodash-es';
import dayjs from 'dayjs';
import type { Tourflow } from '@aviata/platform-types';

import { DateLib } from '@shared/lib';
import type { SelectedDates } from '@entities/dates-picker';

import { EXPIRE_THRESHOLD_DAY_COUNT } from './config';
import type { LastSearch } from './index';

function isSearchHistoryItem(item: unknown): item is LastSearch {
  return (
    isObject(item) &&
    item.townFrom &&
    item.countryTo &&
    isArray(item.townsTo) &&
    item.townsTo.every(isTownsTo) &&
    isNumber(item.adt) &&
    isArray(item.childrenAge) &&
    isDate(item.depDate) &&
    isDate(item.arrDate)
  );
}

export function isSearchHistory(
  searchHistory: unknown[],
): searchHistory is LastSearch[] {
  if (!isArray(searchHistory)) {
    return false;
  }

  return searchHistory.every(item => isSearchHistoryItem(item));
}

function isTownsTo(v: unknown): v is Tourflow.TownTo {
  return isObject(v) && v.id && v.name;
}

function isDate(v: unknown): v is SelectedDates {
  return isObject(v) && v.from && v.to;
}

export function isDateExpired(date: SelectedDates) {
  const today = dayjs(DateLib.getTodayDate());
  const fromDate = dayjs(date.to);

  return (
    today.isAfter(fromDate) ||
    fromDate.diff(today, 'day') <= EXPIRE_THRESHOLD_DAY_COUNT
  );
}
